import { soilSupplyEngineeringConstants } from "../constants";

const initState = {
  query: {},
  list: {}
};

export const soilSupplyEngineerings = (state = initState, action) => {
  switch (action.type) {
    case soilSupplyEngineeringConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          loading: true
        }
      };
    case soilSupplyEngineeringConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        query: {
          projectId: action.projectId,
          queryCondition: action.queryCondition,
          total: action.total,
          queryResult: action.items
        }
      };
    case soilSupplyEngineeringConstants.GET_ALL_FAILURE:
      return {
        ...state,
        query: {
          queryFail: action.error
        }
      };
    case soilSupplyEngineeringConstants.RESET_ALL_SUCCESS:
      return {
        ...state,
        query: {}
      };
    case soilSupplyEngineeringConstants.GET_LIST_REQUEST:
      return {
        ...state,
        list: {
          loading: true,
          listItems: null,
          getListFail: null
        }
      };
    case soilSupplyEngineeringConstants.GET_LIST_SUCCESS:
      return {
        ...state,
        list: {
          loading: false,
          listItems: action.soilSupplyEngineerings,
          getListFail: null
        }
      };
    case soilSupplyEngineeringConstants.GET_LIST_FAILURE:
      return {
        ...state,
        list: {
          loading: false,
          listItems: null,
          getListFail: action.error
        }
      };
    case soilSupplyEngineeringConstants.RESET_LIST_SUCCESS:
      return {
        ...state,
        list: {}
      };
    default:
      return state;
  }
};
